import { getOfferArea } from './area/getOfferArea';
import { getFloorRange } from './floor/getFloorRange';
import { getOfferCategoryTitle } from './title/getOfferCategoryTitle';

import type { IOffer } from 'shared/offer';

export function getOfferName(offer: IOffer) {
  return [getOfferCategoryTitle, getOfferArea, getFloorRange]
    .map(fn => fn(offer))
    .filter(Boolean)
    .join(', ');
}
